import { ButtonProps } from '../../../interface/interface';
import './bigButton.css'

const BigButton = ({ text, onClick, disabled, className }: ButtonProps) => {
    return (
        <button
            className={`button big-button button--red ${className || ''}`.trim()}
            onClick={onClick}
            disabled={disabled}
        >
            {text}
        </button>
    );
};

export default BigButton